<template>
    <div class="mt-5 text-center min-vh-100">
        <h1 class="h3 mt-5 mb-3">
            <strong><img src="/assets/img/loading.svg"></strong>
        </h1>
    </div>
</template>

<script>
export default {
    name: 'Loading',
    components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
